module.exports = __webpack_public_path__ + "assets/719e474daaca61277c68ef00f33fa9d6.mp3";